import type {
  ChatsChannelBase,
  ChatsChannelSetting
} from '../../../constants/types';
import { ChatsChannelType } from '../../../constants/types';
import { getChatIcon } from '../../helpers';

const GM_DIR_URL = 'https://www.google.com/maps/place';

export const getGoogleMapsSettings = ({
  googleMaps
}: Partial<ChatsChannelBase>) => {
  if (!googleMaps) return null;

  const url = `${GM_DIR_URL}/${googleMaps}`;

  return {
    provider: ChatsChannelType.googlemaps,
    link: { url, options: { withFeatures: false } },
    title: 'Open in Google Maps',
    icon: getChatIcon(ChatsChannelType.googlemaps),
    color: 'rgb(25, 123, 255)'
  } as ChatsChannelSetting;
};
